import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { openWhatsApp } from '../lib/analytics';

/**
 * Ruta comodin. Sin esto, cualquier URL desconocida renderizaba el header y el
 * footer con el contenido vacio, sin explicarle nada al visitante.
 *
 * GitHub Pages ya devuelve un 404 real via public/404.html; el noindex es por
 * si acaso, para que esta pantalla no acabe indexada bajo alguna URL.
 */
const NoEncontrada = () => (
  <>
    <Helmet>
      <title>Página no encontrada | Maderas El Ocote</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>

    <div className="min-h-screen flex items-center justify-center bg-white px-5 py-32">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold text-wood-400 uppercase tracking-widest mb-4">Error 404</p>
        <h1 className="text-4xl sm:text-5xl font-heading font-bold text-wood-900 leading-tight mb-5">
          Esta página ya no existe
        </h1>
        <p className="text-lg text-wood-600 leading-relaxed mb-10">
          Puede que el enlace esté mal escrito o que la página se haya movido.
          Si buscabas un material en particular, escríbenos y te decimos si lo manejamos.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
          <Button
            onClick={() => openWhatsApp('pagina_no_encontrada')}
            className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full px-8 py-6 text-base"
          >
            <MessageCircle className="mr-2 w-5 h-5" />
            Preguntar por WhatsApp
          </Button>
          <Link to="/productos">
            <Button
              variant="outline"
              className="w-full sm:w-auto rounded-full border-wood-300 text-wood-900 hover:bg-wood-900 hover:text-white px-8 py-6 text-base"
            >
              Ver el catálogo
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
          {[
            { label: 'Inicio', path: '/' },
            { label: 'Servicios', path: '/servicios' },
            { label: 'Cotizar', path: '/cotizar' },
            { label: 'Contacto', path: '/contacto' },
          ].map((link) => (
            <Link key={link.path} to={link.path} className="text-wood-600 hover:text-wood-900 transition-colors">
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  </>
);

export default NoEncontrada;
